import { render } from "./designfoodslide4.vue?vue&type=template&id=a008bcd6&scoped=true"
import script from "./designfoodslide4.vue?vue&type=script&lang=js"
export * from "./designfoodslide4.vue?vue&type=script&lang=js"

import "./designfoodslide4.vue?vue&type=style&index=0&id=a008bcd6&lang=less&scoped=true"

import exportComponent from "/Users/zhoubenhao/Desktop/行云/numatch/numatch-home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a008bcd6"]])

export default __exports__